import { FC, memo, ReactNode } from 'react'

import { AttentionFilledIcon, Button, CheckFilledIcon, CloseFilledIcon, Text } from '@cash-me/react-components'

import * as S from './styles'

type StatusScreenAction = {
  label: string
  onClick: () => void
  variant: 'solid' | 'text-only'
  color?: 'success' | 'danger' | 'primary' | 'secondary'
  loading?: boolean
  disabled?: boolean
}

type Props = {
  tone: 'success' | 'warning' | 'danger'
  title: string
  description?: ReactNode
  actions?: StatusScreenAction[]
  actionsLayout?: 'stack' | 'responsive'
}

const toneIcon = {
  success: <CheckFilledIcon color="var(--colors-success-background-strong-default)" width={70} height={70} />,
  warning: <AttentionFilledIcon color="var(--colors-warning-icon-default)" width={70} height={70} />,
  danger: <CloseFilledIcon color="var(--colors-danger-background-strong-default)" width={70} height={70} />
}

export const StatusScreen: FC<Props> = memo(({ tone, title, description, actions, actionsLayout = 'stack' }) => (
  <S.Container>
    <span aria-hidden="true">{toneIcon[tone]}</span>
    <S.Title weight="medium">{title}</S.Title>
    {description && <Text size="body1">{description}</Text>}
    {actions && actions.length > 0 && (
      <S.ActionsWrapper $layout={actionsLayout}>
        {actions.map(action => (
          <Button
            key={action.label}
            size="lg"
            variants={action.variant === 'solid' ? 'default' : 'text-only'}
            onClick={action.onClick}
            color={action.color ? action.color : 'primary'}
            loading={action.loading}
            disabled={action.disabled}
          >
            {action.label}
          </Button>
        ))}
      </S.ActionsWrapper>
    )}
  </S.Container>
))

StatusScreen.displayName = 'StatusScreen'
